<template>
  <div>
    <div class="hader">
      <p>
        <span>{{ Number(anIndex) + 1 }}</span>
        <span>[{{ TestItems.Style }}]</span>
        <span v-html="TestItems.Title"></span>
      </p>
    </div>
    <div class="main">
      <template v-if="!practice">
        <el-checkbox-group v-model="UserAnswer">
          <el-checkbox
            :label="item.ItemName"
            v-for="(item, index) in TestItems.SelectedItems"
            :key="index"
            @change="saveAnswer(item)"
          >
            <p :class="practiceColour(item.ItemName)">
              {{ item.ItemName + "." }}
              <span v-html="item.Content"> </span>
            </p>
          </el-checkbox>
        </el-checkbox-group>
      </template>
      <template v-else>
        <el-checkbox-group v-model="UserAnswer">
          <el-checkbox
            :label="item.ItemName"
            v-for="(item, index) in TestItems.SelectedItems"
            :key="index"
          >
            <p :class="practiceColour(item.ItemName)">
              {{ item.ItemName + "." }}
              <span v-html="item.Content"> </span>
            </p>
          </el-checkbox>
        </el-checkbox-group>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      UserAnswer: [],
    };
  },
  methods: {
    // 保存答案
    saveAnswer(item) {
      const myArraytoStringFunction = (input) =>
        input.reduce((a, item) => a + (a === "" ? item : item), "");
      let newarr = this.UserAnswer.sort(); // 答案排序
      let zqAnswer = this.TestItems.Answer.split("").sort().join(""); // 将正确答案进行排序
      const AbswerObj = {
        TestID: this.TestItems.TestID,
        ChildTableID: this.TestItems.TestID,
        Score: this.TestItems.Score,
        UserAnswer: myArraytoStringFunction(newarr), // X题型接收格式ABCDE
        IsRight: myArraytoStringFunction(newarr) == zqAnswer ? true : false,
      };
      this.$emit("userAbswer", AbswerObj);
      // console.log(myArraytoStringFunction(newarr));
    },
    // 回显用户刷新保存上次答案 讲ABC转换为[A,B,C]回显
    theEchoAbswer() {
      this.userAbswerArr.forEach((item) => {
        if (item.TestID == this.TestItems.TestID) {
          this.UserAnswer = item.UserAnswer;
        }
      });
      this.$nextTick(() => {
        let str = this.UserAnswer;
        let str1 = "";
        for (var i = 0; i < str.length; i++) {
          str1 += str[i] + ",";
        }
        str1 = str1.slice(0, -1);
        this.UserAnswer = str1.split(",");
      });
    },
  },
  props: ["TestItems", "anIndex", "userAbswerArr", "practice"],
  computed: {
    practiceColour() {
      return function (item) {
        if (
          this.TestItems.UserAnswer &&
          this.practice &&
          this.TestItems.colourState == true
        ) {
          // 练习状态触发
          if (this.TestItems.Answer.includes(item) == true) {
            return "green";
          } else {
            return "red";
          }
        }
      };
    },
  },
  created() {
    // if (!this.practice) {
    this.UserAnswer = [];
    this.theEchoAbswer();
    console.log(this.TestItems);
    // }
  },
};
</script>

<style lang="scss" scoped>
.hader {
  min-height: 68px;
  display: flex;
  // align-items: center;
  background: #f7f7f7;
  user-select: none;
  padding: 12px 24px;
  p {
    text-align: left;
    span {
      &:nth-child(1) {
        color: #119ce5;
        font-weight: bold;
        font-size: 150%;
        margin: 0px 14px 18px 0px;
      }
      &:nth-child(2) {
        color: #119ce5;
        font-weight: bold;
      }
    }
  }
}
.main {
  padding: 36px 30px;
  user-select: none;
  ::v-deep .el-checkbox-group {
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: flex-start;
    .el-checkbox {
      margin-bottom: 18px;
      .el-checkbox__label {
        font-size: 18px;
      }
    }
  }
}
.green {
  color: rgb(1, 207, 151);
}
.red {
  color: #ee4f3b;
}
</style>
